import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/cuenta/login';


class NotFound extends Component {
    render() {
        const { me } = this.props;
        let returnLink = "/";
        if (me) {
            if (me.rol_usuario) {
                returnLink = me.rol_usuario.initial_view;
            }
        }
        return (
            <div className="d-flex flex-column align-items-center pt-3">
                <div className="error-template">
                    <h1>Oops!</h1>
                    <h2>404 Pagina no encontrada</h2>
                    <div className="error-actions">
                        <Link to={returnLink}> Regresar</Link>
                    </div>
                </div>
            </div>
        );
    }
}

const ms2p = (state) => {
    return {
        ...state.login,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(NotFound);

// export default NotFound;
